export default __webpack_public_path__ + "static/3-becc11f249f682f51fd3c30bdd367a43.png";